import { useMemo, useState } from 'react'

const phrases = [
  'Hoy es un gran día para cerrar una venta.',
  'Cada vehículo publicado es una oportunidad.',
  'La constancia vende más que la suerte.',
  'No se trata de publicar más... sino mejor.',
  'Las oportunidades se mueven rápido. Aprovéchalas!',
  'Es un buen momento para revisar si tus precios siguen siendo competitivos.',
  'Es buena idea subir nuevas fotos a tus vehículos más vistos.',
  'Recuerda revisar tu stock antes de publicar algo nuevo.',
  'Una pequeña mejora en las publicaciones puede tener un gran impacto.',
  '¿Estás al día con las respuestas? ¡Eso marca la diferencia!',
  'Una buena descripción genera confianza.',
  'Mantener tu vitrina clara y actualizada te ayuda a vender más.',
  'Recuerda mantener las fotos actualizadas.',
  'No hace falta hacerlo todo hoy. Con una mejora por día está bien.',
  'Revisa si un vehículo merece estar destacado esta semana.',
  'Una publicación bien hecha ahorra tiempo en respuestas y aclaraciones.',
  'A veces basta con ordenar para ver mejor las oportunidades.',
  '¿Publicamos algo nuevo hoy?',
]

export const usePhrases = () => {
  const [index, setIndex] = useState(Math.floor(Math.random() * phrases.length))
  const phrase = useMemo(() => phrases[index], [index])

  const nextPhrase = () => setIndex((curr) => (curr + 1 < phrases.length ? curr + 1 : 0))

  return { phrase, nextPhrase }
}
